var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid p-4"},[_c('bnp-grid',{key:_vm.keys,attrs:{"hasRowNum":true,"propsColumn":_vm.columns,"propsRows":_vm.rows,"action":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }